import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import DatePicker from 'react-datepicker/es';

export default class InvoiceConfiguration extends Component {
    constructor(props) {
        super(props);

        this.state = {
            errors: {},
            lockOutDate: this.props.lockOutDate ? moment(this.props.lockOutDate).isValid() && moment(this.props.lockOutDate).toDate() : null,
            loading: false,
            showBorder: this.props.showBorder,
        };
    }

    handleDateChange = (date) => {
        let errorsObject = { ...this.state.errors };
        delete errorsObject.lockOutDate;

        if (moment(date).isValid()) {
            this.setState({ lockOutDate: date, errors: errorsObject });
        } else {
            this.setState({ lockOutDate: null });
        }        
    };

    handleSubmit = () => {
        if (!this.state.lockOutDate) {
            this.setState({
                ...this.state.errors,
                lockOutDate: 'Lock out date is required',
            });

            return;
        }

        this.setState({
            loading: true,
        });

        let formData = new FormData();
        formData.append('lockOutDate', moment(this.state.lockOutDate).format('YYYY-MM-DD'));

        axios
            .post(this.props.url, formData)
            .then((res) => {
                toastr.success('Invoice configuration updated');
                this.setState({
                    loading: false,
                });
            })
            .catch(() => {
                toastr.error('Failed to update invoice configuration');
                this.setState({
                    loading: false,
                });
            });
    };

    render() {
        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="card" style={this.state.showBorder ? {} : { border: 'none' }}>
                        <div className="card-header">
                            <h4 className="cart-title">{this.props.title}</h4>
                        </div>
                        <div className="card-body">
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label htmlFor="customers-pricing" className="d-block">
                                        Invoice lock out date
                                    </label>
                                    <DatePicker
                                        className={this.props.errors?.lockOutDate ? 'form-control is-invalid' : 'form-control'}
                                        placeholderText="Lock out date"
                                        selected={this.state.lockOutDate || null}
                                        onChange={this.handleDateChange}
                                        dateFormat="dd/MM/yyyy"
                                    />
                                    {this.state.errors?.lockOutDate ? <p className="text-danger">{this.state.errors.lockOutDate}</p> : ''}
                                </div>
                            </div>
                            <div className="col-md-4">
                                <button
                                    className="btn btn-cw-primary"
                                    onClick={this.handleSubmit}
                                    style={{ minWidth: '175px' }}
                                >
                                    {this.state.loading ? (
                                        <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                        />
                                    ) : (
                                        'Update Invoice Configuration'
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

if (document.getElementById('invoice-configuration')) {
    let element = document.getElementById('invoice-configuration');

    ReactDOM.render(
        <InvoiceConfiguration
            url={element.dataset.url}
            title={element.dataset.title}
            showBorder={element.dataset.show_border}
            lockOutDate={element.dataset.lock_out_date}
        />,
        element
    );
}
